<template>
  <transition name="fade">
    <div
      v-show="isVisible"
      class="dialog"
      :class="arrowPosition">
      <p>
        <slot>
          contenu du dialog
        </slot>
      </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DialogBox',
  props: {
    isVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    arrowPosition: {
      type: String,
      required: false,
      default: 'top'
    }
  }
}
</script>

<style lang=scss>
.dialog {
  background-color: $primary-text-color;
  color: #fff;
  border-radius: $radius-sm;
  padding: 20px 30px;
  position: relative;
  z-index: 2;
  box-shadow: 2px 2px 5px rgba(128, 128, 128, 0.5);
  &:after {
    content: '';
    background-image: url('../assets/icons/arrowDown.svg');
    position: absolute;
    display: inline-block;
    width: 16px;
    height: 30px;
  }
  &.top {
    &:after {
      top: 0;
      left: 50%;
      transform: translateX(-50%) rotate(180deg);
    }
  }
  &.top-right {
    &:after {
      top: -25px;
      left: 94%;
      transform: rotate(180deg);
    }
  }
  &.left {
    &:after {
      left: -20px;
      top: 50%;
      transform: translateY(-50%) rotate(90deg);
    }
  }
}
</style>
